import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet-async';

import './PsychotherapyTypes.css';
import './Disclaimer.css';
import Footer from "./Footer_page";
import introImagePsycho from './assets/psychotherapy/creative-minds-office-collaboration.png';
import psychodynamicImg from './assets/psychotherapy/woman-lying-couch-therapy-session.png';
import Ellipse1 from './assets/psychotherapy/Ellipse1.svg';
import Ellipse2 from './assets/psychotherapy/Ellipse2.svg';
import Ellipse3 from './assets/psychotherapy/Ellipse3.svg';

import circleImage from './assets/psychotherapy/caucasian-teenage-girl.png';
import behavioralImg from './assets/psychotherapy/children-psyhology-concept-session-psychologist-treatment.png';
import cognitiveImg from './assets/psychotherapy/visuals-psychiatric-therapy-counseling-sessions.png';
import humanisticImg from './assets/psychotherapy/back-view-female-therapist-holding-clipboard.png';
import holisticImg from './assets/psychotherapy/energy-healing-session-alternative-therapy-energy-work.png';
import familyImg from './assets/psychotherapy/psychologist-explaining-situation-family-session.png'
import otherImg from './assets/psychotherapy/childs-painting-selective-focus-professional-female-psychologist-holding-childs-painting.png'
import Icon1 from './assets/psychotherapy/icon1.svg';
import Icon2 from './assets/psychotherapy/icon2.svg';
import Icon3 from './assets/psychotherapy/icon3.svg';
import Icon4 from './assets/psychotherapy/icon4.svg';
import Icon5 from './assets/psychotherapy/icon5.svg';
import Icon6 from './assets/psychotherapy/icon6.svg';

// import Vector1 from './assets/psychotherapy/Vector1.svg';
// import Vector2 from './assets/psychotherapy/Vector2.svg';
// import Vector3 from './assets/psychotherapy/Vector3.svg';
// import Vector4 from './assets/psychotherapy/Vector4.svg';
// import Vector5 from './assets/psychotherapy/Vector5.svg';
// import Vector6 from './assets/psychotherapy/Vector6.svg';
// import Vector7 from './assets/psychotherapy/Vector7.svg';
// import Vector8 from './assets/psychotherapy/Vector8.svg';
// import Vector9 from './assets/psychotherapy/Vector9.svg';
// import Vector12 from './assets/psychotherapy/Vector12.svg';



const PsychotherapyTypes = () => {


  const [popup, setPopup] = useState({
        show: false,
        type: "", // "success" | "error"
        message: ""
      });
      

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const API_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:3000"
    : "https://euphoria-backend-oii0.onrender.com";

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!name.trim()) {
      setPopup({
        show: true,
        type: "error",
        message: "Name is required"
      });
      return;
    }
  
    if (!email.trim()) {
      setPopup({
        show: true,
        type: "error",
        message: "Email is required"
      });
      return;
    }
  
   
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      setPopup({
        show: true,
        type: "error",
        message: "Please enter a valid email address"
      });
      return;
    }
  
    try {
      const res = await axios.post(`${API_URL}/api/newsletter/subscribe`, {
        name,
        email,
      });
  
      
      setPopup({
        show: true,
        type: "success",
        message: res.data.message || "Subscribed successfully!"
      });
  
      
      setName("");
      setEmail("");
  
    } catch (error) {
      
      setPopup({
        show: true,
        type: "error",
        message: error.response?.data?.message || "Something went wrong. Please try again."
      });
    }
  };

useEffect(() => {
    if (popup.show) {
      const timer = setTimeout(() => {
        setPopup({ show: false, type: "", message: "" });
      }, 3000);
  
      return () => clearTimeout(timer);
    }
  }, [popup.show]);


  return (
    <>
    <Helmet>
      <title>Psychotherapy & Counseling Services | MindWork360</title>
      <meta name="description" content="Get professional psychotherapy and counseling at MindWork360. Our licensed therapists provide confidential support for anxiety, depression, stress, trauma, relationships, and overall mental well-being." />
      <link rel="canonical" href="https://mindwork360.com/psychotherapy" />
    </Helmet>
    <div className="therapy-container">
    <h1 className="seo-only">Psychotherapy Types | MindWork360</h1>
    <h2 className="seo-only">Types of Psychotherapy & Mental Health Therapy</h2>
    <h3 className="psy_heading_h3">Psychotherapy Types</h3>
      {/* Intro Section */}
      <div className="psy-intro-section">
        <div className="psy-intro-left">
          <div className="psy-intro-bg-box"></div>
          <img src={introImagePsycho} alt="Psychotherapy Intro" title="What Is Psychotherapy — MindWork360" className="psy-intro-img" />
        </div>
        <div className="psy-intro-right">
          <h3 className="psy-intro-title">WHAT IS PSYCHOTHERAPY?</h3>
          <p className="psy-intro-paragraph">
          Online psychotherapy at The School of Life is a truly global service which assists clients from over 40 countries. Our highly skilled and qualified practitioners help you get to the root of issues and will give you new clarity on your past and your present.
          </p>
          <p className="psy-intro-paragraph">
          Our online psychotherapists use the ideas of The School of Life – found in our YouTube films and books – to work with you to unpack your story and offer you a chance to spend concentrated time on yourself, deepening insight into whatever feels most urgent. The journey is always creative, with the therapist actively listening and proposing ideas, perspectives, and challenges with sensitivity and insight.
          </p>
          {/* <button className="psy-read-more">Read More</button> */}
        </div>
      </div>

      <h2 className="psy-main-heading">Types of Psychotherapy</h2>

      <div className="therapy-type-section">
        {/* Section 1: Content Left, Image Right with Circle */}
        <div className="therapy-type-block">
          <div className="therapy-text">
            <h4>Psychodynamic Therapy</h4>
            <ul>
              <li><strong >Psychodynamic Therapy</strong>: Explores unconscious thoughts and early life experiences.</li>
              <li><strong>Brief Psychodynamic Therapy</strong>: A shorter, focused version of psychodynamic therapy.</li>
            </ul>
          </div>
          <div className="therapy-image-wrapper">
            <img src={psychodynamicImg} alt="Psychodynamic Therapy" title="Psychodynamic Therapy — MindWork360" className="therapy-img" />
            <img src={circleImage} alt="" title="" className="circle-image" />
            <img src={Ellipse1} alt="" title="" className="green-circle" />
            <img src={Ellipse2} alt="" title="" className="green-circle1" />
           
          </div>
        </div>

        {/* Section 2: Image Left, Content Right */}
        <div className="therapy-type-block reverse">
          <div className="therapy-image-wrapper">
            <img src={behavioralImg} alt="Behavioral Therapy" title="Behavioral Therapy — MindWork360" className="therapy-img3" />
            <img src={Ellipse3} alt="" title="" className="green-circle2" />
          </div>
          <div className="therapy-text">
            <h4>Behavioral Therapy</h4>
            <ul>
              <li><strong>Applied Behavior Analysis (ABA)</strong>: Often used for autism and behavioral issues.</li>
              <li><strong>Exposure Therapy</strong>: Helps with phobias and anxiety by gradual exposure.</li>
              <li><strong>Aversion Therapy</strong>: Links unwanted behavior with discomfort.</li>
            </ul>
          </div>
        </div>

        {/* Section 3: Image Farther Left, Content Right */}
        <div className="therapy-type-block reverse offset-image-left">
          <div className="therapy-image-wrapper offset-img-wrapper">
            <img src={cognitiveImg} alt="Cognitive Therapy" title="Cognitive Therapy — MindWork360" className="therapy-img1" />
            <img src={Ellipse1} alt="" title="" className="green-circle3" />
          </div>
          <div className="therapy-text">
            <h4>Cognitive Therapy</h4>
            <ul>
              <li><strong>Cognitive Behavioral Therapy (CBT)</strong>: Combines cognitive and behavioral strategies.</li>
              <li><strong>Rational Emotive Behavior Therapy (REBT)</strong>: Focuses on challenging irrational beliefs.</li>
              <li><strong>Mindfulness-Based Cognitive Therapy (MBCT)</strong>: Combines cognitive therapy with mindfulness strategies.</li>
            </ul>
          </div>
        </div>

        {/* Section 4: Content Left, Image Right */}
        <div className="therapy-type-block">
          <div className="therapy-text">
            <h4>Humanistic Therapy</h4>
            <ul>
              <li><strong>Client-Centered (Rogerian) Therapy</strong>: Emphasizes empathy and unconditional positive regard.</li>
              <li><strong>Gestalt Therapy</strong>: Focuses on awareness and the present moment.</li>
              <li><strong>Existential Therapy</strong>: Explores meaning, freedom, and responsibility.</li>
            </ul>
          </div>
          <div className="therapy-image-wrapper">
            <img src={humanisticImg} alt="Humanistic Therapy" title="Humanistic Therapy — MindWork360" className="therapy-img3" />
            <img src={Ellipse2} alt="" title="" className="green-circle4" />
          </div>
        </div>

        {/* Section 5: Image Left, Content Right */}
        <div className="therapy-type-block reverse">
          <div className="therapy-image-wrapper">
            <img src={holisticImg} alt="Holistic Therapy" title="Holistic & Integrative Therapy — MindWork360" className="therapy-img2" />
          </div>
          <div className="therapy-text">
            <h4>Holistic & Integrative Therapy</h4>
            <ul>
              <li><strong>Integrative Psychotherapy</strong>: Tailors different approaches to fit the client.</li>
              <li><strong>Transpersonal Therapy</strong>: Includes spiritual aspects of the human experience.</li>
            </ul>
            <h5>Somatic & Body-Centered Therapy</h5>
            <ul>
              <li><strong>Somatic Experiencing</strong>: Focuses on the body's awareness to release trauma.</li>
              <li><strong>Sensorimotor Psychotherapy</strong>: Combines somatic and attachment theories.</li>
            </ul>
          </div>
        </div>

        {/* Section 6: Content Left, Image Right */}
        <div className="therapy-type-block">
          <div className="therapy-text">
            <h4>Family & Couples Therapy</h4>
            <ul>
              <li><strong>Systemic Therapy</strong>: Looks at family dynamics and patterns.</li>
              <li><strong>Emotionally Focused Therapy (EFT)</strong>: Strengthens emotional bonds.</li>
              <li><strong>Gottman Method</strong>: Evidence-based therapy for couples.</li>
            </ul>
          </div>
          <div className="therapy-image-wrapper">
            <img src={familyImg} alt="Family & Couples Therapy" title="Family & Couples Therapy — MindWork360" className="therapy-img3" />
            <img src={Ellipse3} alt="" title="" className="green-circle5" />
          </div>
        </div>
        {/* Section 7: Image Left, Content Right */}
        <div className="therapy-type-block reverse">
          <div className="therapy-image-wrapper">
            <img src={otherImg} alt="Other Specialized Therapies" title="Other Specialized Therapies — MindWork360" className="therapy-img" />
          </div>
          <div className="therapy-text">
            <h4>Other Specialized Therapies</h4>
            <ul>
              <li><strong>Dialectical Behavior Therapy (DBT)</strong>: Designed for emotion regulation and borderline personality disorder.</li>
              <li><strong>Acceptance and Commitment Therapy (ACT)</strong>: Uses mindfulness and values-based living.</li>
              <li><strong>Eye Movement Desensitization and Reprocessing (EMDR)</strong>: Treats trauma and PTSD.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    {/* Newsletter Section */}
<div className="newsletter-section">
  <div className="newsletter-left">
    <h3>Ideas to Help You Learn, Heal and Grow</h3>
    <p>
      Get weekly insights for better relationships, deeper self-knowledge, and inner calm.
      Sign up for inspiration, plus 10% off your first shop order.
      By signing up, you agree to receive email marketing material from The School of Life.
      You can unsubscribe at any time. For more details, please refer to our Privacy Policy.
    </p>
  </div>
  <div className="newsletter-form">
      <form onSubmit={handleSubmit}>
        <label>Name</label>
        <input 
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Name"
        />

        <label>Email</label>
        <input 
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
        />

        <button type="submit">Submit</button>
      </form>
    </div>
</div>

{popup.show && (
          <div
            className="popup-overlay"
            onClick={() => setPopup({ show: false, type: "", message: "" })}
          >
            <div
              className={`popup ${popup.type}`}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="icon-wrapper">
                {popup.type === "success" ? (
                  <svg className="success-icon" viewBox="0 0 52 52">
                    <circle className="success-circle" cx="26" cy="26" r="25" />
                    <path className="success-check" d="M14 27l7 7 17-17" />
                  </svg>
                ) : (
                  <svg className="error-icon" viewBox="0 0 52 52">
                    <circle className="error-circle" cx="26" cy="26" r="25" />
                    <path className="error-cross" d="M16 16 36 36 M36 16 16 36" />
                  </svg>
                )}
              </div>

              <p className="popup-message">{popup.message}</p>
            </div>
          </div>
        )}



<div className="therapy-benefits-wrapper desktop-layout">
<div className="therapy-benefits-wrapper">
  {/* <svg className="therapy-svg-lines" viewBox="0 0 800 600" xmlns="http://www.w3.org/2000/svg">
    <circle cx="400" cy="300" r="220" fill="none" stroke="#C5D8A4" strokeWidth="1.5" strokeDasharray="6 4"/>
  </svg> */}
{/* <img src={Vector1} alt="Icon1" className="therapy-icon vector1" />
<img src={Vector2} alt="Icon1" className="therapy-icon vector1" />
<img src={Vector3} alt="Icon1" className="therapy-icon vector2" />
<img src={Vector4} alt="Icon1" className="therapy-icon vector3" />
<img src={Vector5} alt="Icon1" className="therapy-icon vector3" />
<img src={Vector6} alt="Icon1" className="therapy-icon vector4" />
<img src={Vector1} alt="Icon1" className="therapy-icon vector6" />
<img src={Vector2} alt="Icon1" className="therapy-icon vector6" />
<img src={Vector3} alt="Icon1" className="therapy-icon vector7" />
<img src={Vector4} alt="Icon1" className="therapy-icon vector8" />
<img src={Vector5} alt="Icon1" className="therapy-icon vector8" />
<img src={Vector6} alt="Icon1" className="therapy-icon vector9" /> */}
  <img src={Icon1} alt="" title="" className="therapy-icon icon1" />
  <img src={Icon2} alt="" title="" className="therapy-icon icon2" />
  <img src={Icon3} alt="" title="" className="therapy-icon icon3" />
  <img src={Icon5} alt="" title="" className="therapy-icon icon4" />
  <img src={Icon4} alt="" title="" className="therapy-icon icon5" />
  <img src={Icon6} alt="" title="" className="therapy-icon icon6" />

  <div className="therapy-center-text">How Exactly Can Therapy Help Us?</div>

  <div className="benefit-text bt2">Improved Self-Awareness</div>
  <div className="benefit-text bt1">Emotional Support</div>
  <div className="benefit-text bt3">Better Relationships</div>
  <div className="benefit-text bt4">Behavioral Change</div>
  <div className="benefit-text bt5">Goal Clarity and Motivation</div>
  <div className="benefit-text bt6">Mental Health Management</div>
  <div className="benefit-text bt7">Healing from Trauma</div>
  <div className="benefit-text bt8">Coping Strategies</div>
  <div className="benefit-text bt9">Problem-Solving Skills</div>
  <div className="benefit-text bt10">Increased Resilience</div>
</div>
</div>
<div className="therapy-benefits-wrapper-mobile">
  <div className="therapy-center-text">How Exactly Can Therapy Help Us?</div>

  <div className="therapy-mobile-pair">
    <img src={Icon1} alt="" title="" className="therapy-icon" />
    <div className="therapy-benefit-texts">
      <div className="benefit-text">Improved Self-Awareness</div>
      <div className="benefit-text">Emotional Support</div>
    </div>
  </div>

  <div className="therapy-mobile-pair">
    <img src={Icon2} alt="" title="" className="therapy-icon" />
    <div className="therapy-benefit-texts">
      <div className="benefit-text">Better Relationships</div>
      <div className="benefit-text">Behavioral Change</div>
    </div>
  </div>

  <div className="therapy-mobile-pair">
    <img src={Icon3} alt="" title="" className="therapy-icon" />
    <div className="therapy-benefit-texts">
      <div className="benefit-text">Goal Clarity and Motivation</div>
      <div className="benefit-text">Mental Health Management</div>
    </div>
  </div>

  <div className="therapy-mobile-pair">
    <img src={Icon4} alt="" title="" className="therapy-icon" />
    <div className="therapy-benefit-texts">
      <div className="benefit-text">Healing from Trauma</div>
      <div className="benefit-text">Coping Strategies</div>
    </div>
  </div>

  <div className="therapy-mobile-pair">
    <img src={Icon5} alt="" title="" className="therapy-icon5" />
    <div className="therapy-benefit-texts">
      <div className="benefit-text">Problem-Solving Skills</div>
      <div className="benefit-text">Increased Resilience</div>
    </div>
  </div>
</div>


{/* --- FOOTER SECTION --- */}
<div className="disclaimer-section">
  <h2 className="disclaimer-heading">Disclaimer</h2>
  <p className="disclaimer-text">
    MindWork360 is a community and educational platform and does not provide medical advice,
    diagnosis, or emergency services. If you're in immediate danger or think you may harm
    yourself or someone else, please contact your local mental health emergency number right
    now or reach out to a crisis hotline in your country of residence. You can find such
    resources on our website at <a href="https://www.mindwork360.com" target="_blank" rel="noopener noreferrer">www.mindwork360.com</a>
  </p>
</div>
<Footer />


    </>
  );
};

export default PsychotherapyTypes;
